import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";


const ReportRoutes = () => {

  const [t] = useTranslation("routes")

  const bread = [
    {name: t("labels.reports"), url:"/reports/", current: false},
    {name: t("labels.routes"), current: true}
  ]

  useEffect(() => {
    console.log("load ReportRoutes");
  }, []);

  return (
    <>
      <NavBreadcrum navs={navs} bread={bread}/>
      <div className="row">
        <div className="col-12">
          <h1>ReportRoutes</h1>
        </div>
      </div>
    </>
  )
}
export default ReportRoutes;